import axiosInstance from '../../utils/axios';

export const partnerService = {
  // Register a new partner (Restaurant, Shop, or Activity)
  registerPartner: async (partnerData) => {
    try {
      const response = await axiosInstance.post('/agent/register-partner', partnerData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to register partner' };
    }
  },

  // Upload multiple images
  uploadMultipleImages: async (formData) => {
    try {
      const response = await axiosInstance.post('/upload/multiple', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to upload images' };
    }
  },

  // Get locations (needed for the form)
  getLocations: async () => {
    try {
      const response = await axiosInstance.get('/location');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch locations' };
    }
  },

  // Get agent's registered partners
  getPartners: async () => {
    try {
      const response = await axiosInstance.get('/agent/partners');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch partners' };
    }
  },

  updatePartner: async (id, partnerData) => {
    try {
      const response = await axiosInstance.put(`/agent/partners/${id}`, partnerData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to update partner' };
    }
  },

  freezePartner: async (id, category) => {
    try {
      const response = await axiosInstance.put(`/agent/partners/${id}/freeze`, { category });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to freeze partner' };
    }
  },

  deletePartner: async (id, category) => {
    try {
      const response = await axiosInstance.delete(`/agent/partners/${id}?category=${category}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete partner' };
    }
  }
};
